import type { PiperWorkerLike } from './piper-engine'

/** Spawns the Piper worker. Kept in its own module because Vite only bundles
 * the worker (and its WASM runtimes) when `new Worker(new URL(...))` appears
 * literally; the worker chunk is fetched only when this is first called, i.e.
 * after the visitor agreed to use the site voices. */
export function createPiperWorker(): PiperWorkerLike {
  return new Worker(new URL('./piper.worker.ts', import.meta.url), { type: 'module' })
}
